import { DEVICES, OS, PAGE_TYPE } from 'src/constants';
import { IAppPage, IStoreState } from 'src/interface';

export const menuConfigSelector = (state: IStoreState) =>
    state.app.config.menus;
export const tagConfigSelector = (state: IStoreState) =>
    state.app.config.tags || [];
export const categoryConfigSelector = (state: IStoreState) =>
    state.app.config.categories;
export const pageSelector = (state: IStoreState): IAppPage => state.app.page;
export const isPageContentDetailSelector = (state: IStoreState): boolean =>
    state.app.page?.type === PAGE_TYPE.CONTENT_DETAIL;

export const suggestTTSSelector = (state: IStoreState) => state.app.region?.tts;
export const regionLoadedSelector = (state: IStoreState) =>
    state.app.regionLoaded;
export const provinceSelector = (state: IStoreState) =>
    state.app.region?.province || '';
export const regionSelector = (state: IStoreState) =>
    state.app.region?.region || {};
export const isOnlineSelector = (state: IStoreState) => state.app.isOnline;
export const isMobileSelector = (state: IStoreState) =>
    state.app.device === DEVICES.MOBILE;
export const isDesktopSelector = (state: IStoreState) =>
    state.app.device === DEVICES.DESKTOP;
export const isIosSelector = (state: IStoreState) => state.app.os === OS.IOS;
export const isIABMSelector = (state: IStoreState) => state.app.isIABM;
export const isZaloSeletor = (state: IStoreState) => state.app.isZalo;
export const isBotSelector = (state: IStoreState) => state.app.isBot;
export const approveConsentSelector = (state: IStoreState) =>
    state.app.approveConsent;
export const isMiniappSelector = (state: IStoreState) => state.app.isMiniapp;
